export default "__VITE_ASSET__6380c09e__"